import React from 'react';
import { MonitoringDashboardKPIs } from './types';

interface Props {
  kpis?: MonitoringDashboardKPIs | null;
  metrics?: MonitoringDashboardKPIs | null;
  onRefresh?: () => void;
}

export const ComplianceMonitoringMetricsCards: React.FC<Props> = ({ kpis, metrics, onRefresh: _onRefresh }) => {
  const data = kpis || metrics;
  const coverage = data?.monitoring_coverage_percentage ?? 0;
  const completedReviews = data?.completed_reviews ?? 0;
  const totalReviews = data?.total_reviews ?? 0;
  const overallComplianceRate = data?.overall_compliance_rate ?? 0;
  const activeProgrammesCount = data?.active_programmes_count ?? 0;
  const openFindings = data?.open_findings ?? 0;
  const criticalFindings = data?.critical_findings ?? 0;
  const verifiedActions = data?.verified_actions ?? 0;
  const totalActions = data?.total_actions ?? 0;
  const overdueReviews = data?.overdue_reviews ?? 0;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Programme Coverage</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{coverage}</span>
        <span className="stat-sub">{completedReviews}/{totalReviews} Reviews Completed</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Assurance Score</span>
        <span className="stat-value" style={{ color: '#059669' }}>%{overallComplianceRate}</span>
        <span className="stat-sub">{activeProgrammesCount} Active Programmes</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Compliance Findings</span>
        <span className="stat-value" style={{ color: criticalFindings > 0 ? '#dc2626' : '#d97706' }}>
          {openFindings}
        </span>
        <span className="stat-sub">{criticalFindings} Critical Level 1 Findings</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Actions & Overdue</span>
        <span className="stat-value" style={{ color: overdueReviews > 0 ? '#dc2626' : '#4f46e5' }}>
          {verifiedActions}/{totalActions}
        </span>
        <span className="stat-sub">{overdueReviews} Overdue Reviews</span>
      </div>
    </div>
  );
};
